/**
 * Mappers for positions list operations
 */

import type {
  LC_GetPositionsListOut,
  LC_PositionListItem,
  PositionListItem,
  PositionsListResult,
} from '../types';


export function mapPositionListItemFromTransport(
  transport: LC_PositionListItem,
): PositionListItem {
  return {
    id: transport.positionId,
    code: transport.positionCode,
    name: transport.positionName,
    description: transport.description,
    areaId: transport.areaId,
    areaName: transport.areaName,
    modifiedDate: transport.modifiedDate || undefined,
    modifiedBy: transport.modifiedBy || undefined,
    isEnabled: transport.isEnabled,
  };
}

export function mapPositionsListFromTransport(
  transport: LC_GetPositionsListOut,
): PositionsListResult {
  return {
    items: transport.data ? transport.data.map(mapPositionListItemFromTransport) : [],
    page: transport.pagination.currentPage,
    pageSize: transport.pagination.pageSize,
    totalRecords: transport.pagination.totalRecords,
    totalPages: transport.pagination.totalPages,
  };
}
